import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export default function JumpButton({ href }) {
    return (<Link to={href} className='w-12 h-12 rounded-full bg-white flex items-center justify-center transition-all hover:-translate-y-1 hover:shadow-lg' aria-label='詳しく見る'>
      <ArrowUpRight className='text-navy' size={20}/>
    </Link>);
}
